"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineHeights = void 0;
exports.lineHeights = {
    lineHeight100: 16,
    lineHeight200: 16.6,
    lineHeight300: 18,
    lineHeight400: 19.36,
    lineHeight500: 21.78,
    lineHeight600: 24,
    lineHeight700: 29.05,
    lineHeight800: 38.73,
    lineHeight900: 53.32
};
